var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "related-transaction-container" },
        [
          _c(
            "div",
            {
              staticClass:
                "is-flex is-justify-content-space-between p-2 mb-2 related-transaction-details",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "is-flex is-flex-direction-column related-transaction-content last",
                },
                [
                  _c("span", { staticClass: "is-size-4 has-text-primary" }, [
                    _vm._v(_vm._s(_vm.$t("transactions.transactionAmount"))),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "is-flex is-flex-direction-column related-transaction-content last",
                },
                [
                  _vm.transaction.amount > 0
                    ? _c(
                        "span",
                        { staticClass: "has-text-weight-semibold is-size-4" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.formatNumberByCountry(_vm.transaction.amount)
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.transaction.usedClientBalance > 0
                    ? _c(
                        "div",
                        { staticClass: "is-size-7 mt-2" },
                        [
                          _c(
                            "b-tag",
                            {
                              attrs: {
                                rounded: "",
                                type: "is-primary is-light",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("transactions.usedClientBalance")
                                  ) +
                                  ": "
                              ),
                              _c(
                                "span",
                                { staticClass: "has-text-weight-semibold" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatNumberByCountry(
                                        _vm.transaction.usedClientBalance
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ]
          ),
          _vm._l(_vm.transaction.selectedPayments, function (operation) {
            return _c("div", { key: operation.operationId }, [
              _c(
                "div",
                {
                  staticClass:
                    "is-flex is-justify-content-space-between p-2 mb-3 related-transaction-details",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "is-flex is-flex-direction-column related-transaction-content",
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "is-size-6 has-text-primary" },
                        [_vm._v(_vm._s(_vm.$t("generalWords.Operation")))]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "has-text-weight-semibold has-text-grey",
                        },
                        [
                          _c(
                            "b-tooltip",
                            {
                              attrs: {
                                type: "is-primary is-light",
                                label: _vm.getOperationTypeTitle(
                                  operation.type
                                ),
                                dashed: "",
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(operation.companyOperationId) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "is-flex is-flex-direction-column related-transaction-content last",
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "is-size-6 has-text-primary" },
                        [_vm._v(_vm._s(_vm.$t("generalWords.Amount")))]
                      ),
                      _vm._l(operation.payments, function (payment) {
                        return _c(
                          "span",
                          {
                            key: `${operation.operationId}-${payment.paymentNumber}`,
                            staticClass:
                              "has-text-weight-medium has-text-grey mb-1",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatNumberByCountry(
                                    payment.secondaryCurrencyTotalMonthlyPayment ||
                                      payment.totalMonthlyPayment
                                  )
                                ) +
                                " "
                            ),
                            _c(
                              "b-tag",
                              {
                                staticClass: "has-text-weight-light mx-1",
                                attrs: {
                                  rounded: "",
                                  type: "is-primary is-light",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("generalWords.Payment")) +
                                    " " +
                                    _vm._s(payment.paymentNumber)
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                      operation.payments.length > 1
                        ? _c("div", [
                            _c(
                              "div",
                              { staticClass: "has-text-grey is-size-6 mt-4" },
                              [
                                _vm._v(
                                  " Total " +
                                    _vm._s(_vm.$t("generalWords.payments")) +
                                    ": "
                                ),
                                _c(
                                  "span",
                                  { staticClass: "has-text-weight-semibold" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatNumberByCountry(
                                          _vm.sumIndividualOperationPayments(
                                            operation.payments
                                          )
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
            ])
          }),
        ],
        2
      ),
      _vm.transaction.provider === "SERVIPAG_BUTTON"
        ? _c(
            "b-notification",
            {
              staticClass: "servipag-related-transaction-warning m-5",
              attrs: {
                type: "is-warning",
                "aria-close-label": "Close message",
              },
            },
            [
              _c("p", [
                _vm._v(
                  "Tu pago está siendo procesado, esto puede tomar hasta tres días hábiles."
                ),
              ]),
              _c("p", [
                _vm._v(
                  "Si intentaste pagar con Servipag, pero estás seguro de que tu pago no ocurrió, puedes anularlo y pagar nuevamente."
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm.displayCancelButton !== "hide"
        ? _c("div", [
            _c(
              "button",
              {
                staticClass:
                  "cancel-transaction-button button is-button-primary is-rounded",
                attrs: { disabled: _vm.displayCancelButton === "disabled" },
                on: {
                  click: function ($event) {
                    return _vm.$emit(
                      "open-cancel-transaction-modal",
                      _vm.transaction._id
                    )
                  },
                },
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("transactions.cancelTransaction"))),
                ]),
              ]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }